<template>
	<div>
		<!-- Null -->
		<div v-if="!items.length && !loading" class="flex-center pad-8 mb-8 fs-13 color-gray fw-500 text-center">
			<icon-check-slim /><span class="ml-8">You're all caught up.</span>
		</div>

		<template v-if="items.length">
			<div class="flex-right py-8 pr-16">
				<button class="btn btn-link" @click.stop="markAllAsRead">Mark All as Read</button>
			</div>
			<div v-for="(item, i) in items.slice(0, this.displayCount)" :key="item.id" class="droplist-item flex" @click="followNotification(item)">	
				<div class="pl-32 color-violet content">
					<div class="notification-icon" @click.stop="readNotification(item, i, $event)">
						<icon-check-slim width="8" />
					</div>
					<div class="fw-500 fs-14 lh-16 mb-4">{{ item.content }}</div>
					<div class="meta fs-10 lh-12">
						<div class="date">{{ getTimeAgo(item) }}</div>
						<div class="mark-as-read">Mark as Read</div>
					</div>
				</div>
			</div>
		</template>
		<div class="text-center mt-12 lh-14 pb-8">
			<router-link :to="{ name: $routes.Notifications.name  }" class="fs-12">
				View All Notifications
			</router-link>
		</div> 
	</div>
</template>

<script>
import { DateTime, Interval } from 'luxon';
import { request } from '@/plugins/axios';

export default {
	name: 'NotificationDroplist',
	data() {
		return {
			items: [],
			displayCount: 5,
			loading: false,
			today: new Date().setHours(0, 0, 0, 0),
			todayInterval: null,
		};
    },
	methods: {
		fetchData() {
			request({
				url: '/messaging/web?limit=20',
				method: 'get',
			}).then((response) =>{
				this.items = response.data;
				this.loading = false;
			});
		},
		fetchMore() {
			request({
				url: '/messaging/web?status=unread&limit=10&offset=10',
				method: 'get',
			}).then((response) =>{
				this.items = this.items.concat(response.data);
			});
		},
		getTimeAgo(notification) {
			const now = DateTime.now();
			const ago = DateTime.fromISO(notification.createdAt);
			const i = Interval.fromDateTimes(ago, now);
			const months = Math.floor(i.length('months'));
			const days = Math.round(i.length('days'));
			const hours = Math.round(i.length('hours'));

			// Display time if Same day
			if ( ago.c.day == now.c.day && ago.c.month == now.c.month ) {
				return ago.toLocaleString(DateTime.TIME_SIMPLE);
			}

			if ( months >= 1 ) {
				return `${months} month${ months > 1 ? 's' : ''} ago`; // X month(s) ago
			} else if ( days >= 1 ) {
				return `${days} day${ days > 1 ? 's' : ''} ago`; // X days(s) ago
			}

			// X hour(s) ago
			return `${Math.round(hours)} hour${ hours >= 2 ? 's' : ''} ago`;
		},
		markAllAsRead() {
			request({
				url: '/messaging/web/all/read',
				method: 'post',
			})
			this.items = [];
		},
		followNotification(notification) {
			this.readNotification(notification, false);
			let route = false;

			switch (notification.notificationType) {
				case 'jobOffer':
				case 'jobOfferExpired':
				case 'jobAccepted':
				case 'jobDetailsChanged':
				case 'jobChangesApproved':
				case 'jobDeclinedForEventChanges':
				case 'upcomingEventReminder':
					route = { name: this.$routes.JobDetails.name, params: notification.meta };
					break;
				case 'jobOfferForTrial':
					route = { name: this.$routes.Dashboard.name  }; 
					break;
				case 'leaveReview':
				case 'leaveReviewReminder':
				case 'leaveReviewLastChance':
					route = { name: this.$routes.ReviewsCreate.name, query: notification.meta };
					break;
				case 'newReview':
					route = { name: this.$routes.Profile.name };
					break;
				case 'newMessage':
					route = { name: 'thread', params: notification.meta };
					break;
				case 'accountInformationChanged':
					route = { name: this.$routes.AccountInfo.name };
					break;
				case 'paymentFailure':
					route = { name: this.$routes.PaymentHistory.name };
					break;
				case 'updateAvailability':
					route = { name: this.$routes.Availability.name };
					break;
				default: {
					const content = String(notification.content);
					if (content.startsWith('This is just a friendly reminder to update your availability')) {
						// Some older availability reminders don't have the correct "notificationType"
						route = { name: this.$routes.Availability.name };
					}
					break;
				}
			}

			if (route) {
				this.$router.push(route);
			}
		},
		async readNotification(notification, index, event) {
			// Animate removal then actually remove from items array
			if ( event ) {
				event.target.parentElement.classList.add('is-removing');

				setTimeout(() => {
					this.items.splice(index, 1);

					if ( this.items.length == 10 ) {
						this.fetchMore();
					}
				}, 200);
			}

			this.$store.dispatch('notifications/readNotifications', [notification.id]);
		},
	},
    mounted() {
		this.todayInterval = setInterval(() => {
			this.today = new Date().setHours(0, 0, 0, 0);
		}, 10000);

		this.fetchData();
	},
    beforeDestroy() {
		clearInterval(this.todayInterval);
    },
};

</script>
